<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section v-if="showKitNotice" class="recent-ancetry-wrapper">
        <div class="container">
          <div class="row">
            <KitPendingNotice product="Viking ancestry" />
          </div>
        </div>
      </section>
      <page-loader v-else-if="loadingStatus == 'loading'" />
      <section v-else-if="loadingStatus == 'loaded'" class="result-wrapper">
        <div class="container">
          <div class="row">
            <VikingsNavigation />
            <router-view v-if="vikingResult.closestPop" :viking-result="vikingResult" />
          </div>
        </div>
      </section>
      <VikingStatus v-else :status="loadingStatus" />
    </div>
  </div>
</template>
<script>
import Header from "@/components/header/Header.vue";
import VikingStatus from "@/view/vikings/VikingsStatus.vue"
import VikingsNavigation from "@/view/vikings/VikingsNavigation.vue";
import { ref, computed } from "vue";
import store from "@/store/index";
import { getVikingResult } from "@/services/vikings";
import KitPendingNotice from "@/components/kit/KitPendingNotice.vue";
import { useAncestryKit } from "@/composables/useAncestryKit";

const actions = {
  completed: (loadingStatus, vikingResult) => {
    getVikingResult(store.getters.profile.profile.barcode)
      .then((res) => (vikingResult.value = res))
      .then(() => (loadingStatus.value = "loaded"))
      .catch((e) => {
        console.error(e);
        loadingStatus.value = "loadingFailed";
      });
    loadingStatus.value = "loaded";
  },
  // A test being updated to a new version keeps its previous results meanwhile
  updating: (loadingStatus, vikingResult) => actions.completed(loadingStatus, vikingResult),
  error: (loadingStatus) => {
    loadingStatus.value = "testErrored";
  },
  failed: (loadingStatus) => {
    loadingStatus.value = "testFailed";
  },
  pending: (loadingStatus) => {
    loadingStatus.value = "resultPending";
  },
  noData: (loadingStatus) => {
    loadingStatus.value = "testNoData";
  },
  processing: (loadingStatus) => {
    loadingStatus.value = "resultPending";
  },
};

export default {
  name: 'vikings-main',
  components: { Header, VikingsNavigation, VikingStatus, KitPendingNotice },
  setup() {
    // A kit on its way to results that includes Viking: where it's up to
    const { pending: kitPending } = useAncestryKit();
    const showKitNotice = computed(() => kitPending.value && store.getters.kitTests?.viking?.purchased === true);
    const loadingStatus = ref("loading");
    const vikingResult = ref({});
    // A status this page doesn't know reads as still being processed, not a loader for good
    const showStatus = () => {
      const viking = store.getters.kitTests?.viking;
      if (!viking) {
        loadingStatus.value = "loadingFailed";
      } else if (!viking.purchased) {
        loadingStatus.value = "notPurchased";
      } else {
        (actions[viking.status] ?? actions.pending)(loadingStatus, vikingResult);
      }
    };
    // The kit's tests are missing when they failed to load on the way in: ask for them again
    if (store.getters.kitTests?.viking) {
      showStatus();
    } else {
      store.dispatch("SET_KIT_TESTS", store.getters.profile?.profile?.barcode).catch(() => {}).finally(showStatus);
    }
    return { loadingStatus, vikingResult, showKitNotice };
  }

};
</script>